function fn_nl_fog($wrapper, $scene) {
    $.getScript("https://cdnjs.cloudflare.com/ajax/libs/three.js/r83/three.min.js", function() {
        if(window.WebGLRenderingContext) {
            $wrapper.prepend('<script id="vs" type="x-shader/x-vertex">varying vec2 vUv;void main() {vUv = uv;gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );}</script><script id="fs" type="x-shader/x-fragment">uniform sampler2D map;uniform vec3 fogColor;uniform float fogNear;uniform float fogFar;varying vec2 vUv;void main() {float depth = gl_FragCoord.z / gl_FragCoord.w;float fogFactor = smoothstep( fogNear, fogFar, depth );gl_FragColor = texture2D( map, vUv );gl_FragColor.w *= pow( gl_FragCoord.z, 20.0 );gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );}</script>');

            var container = $wrapper.get(0),
                camera = new THREE.PerspectiveCamera(10, window.innerWidth / window.innerHeight, 1, 1500),
                scene = new THREE.Scene(),
                geometry = new THREE.Geometry(),
                texture = THREE.ImageUtils.loadTexture('../img/parallax/fog.png', null),
                fog = new THREE.Fog(0xFFFFFF, 0, 500),
                fog_duration = 6400,
                fog_animation = null,
                material = new THREE.ShaderMaterial({
                    uniforms      : {

                        "map"     : { type: "t", value: texture },
                        "fogColor": { type: "c", value: fog.color },
                        "fogNear" : { type: "f", value: fog.near },
                        "fogFar"  : { type: "f", value: fog.far }

                    },
                    vertexShader  : document.getElementById('vs').textContent,
                    fragmentShader: document.getElementById('fs').textContent,
                    depthWrite    : false,
                    depthTest     : false,
                    transparent   : true
                }),
                plane = new THREE.Mesh(new THREE.PlaneGeometry(10, 30)),
                time = Date.now();

            for( var i = 0; i < fog_duration; i++ ) {
                plane.position.x = Math.random() * 480 - 240;
                plane.position.y = (-Math.random() * Math.random());
                plane.position.z = i;
                plane.rotation.z = Math.random() * Math.PI;
                plane.scale.x = plane.scale.y = Math.random() * Math.random() * 1.5 + 0.5;

                plane.updateMatrix();
                geometry.merge(plane.geometry, plane.matrix);
            }

            var mesh = new THREE.Mesh(geometry, material);
                mesh.position.z = -fog_duration;
                scene.add(mesh);

            var renderer = new THREE.WebGLRenderer({ antialias: false, alpha: true });
                renderer.setSize(container.clientWidth, container.clientHeight);
                $scene.appendChild(renderer.domElement);

            $(window).on("scroll",fn_fog_scroll).on("resize",function() {
                camera.aspect = window.innerWidth / window.innerHeight;
                camera.updateProjectionMatrix();
                renderer.setSize(container.clientWidth, container.clientHeight);
            });

            fn_fog_animate();
            fn_fog_scroll();

            setTimeout(function(){
                $wrapper.find("canvas").css("opacity","0.7")
            },50);
        }

        function fn_fog_scroll() {
            if( fog_animation !== false && $(document).scrollTop() > $wrapper.height() + 96 ) {
                cancelAnimationFrame(fog_animation);
                fog_animation = false;
            }
            else if( fog_animation === false && $(document).scrollTop() <= $wrapper.height() + 96 ) {
                fog_animation = requestAnimationFrame(fn_fog_animate);
            }
        }

        function fn_fog_animate() {
            var position = (( Date.now() - time ) * 0.02) % fog_duration;
                fog_animation = requestAnimationFrame(fn_fog_animate);

            camera.position.x += 0;
            camera.position.y += 0;
            camera.position.z = -position;

            renderer.render(scene, camera);
        }
    });
}